import "./css/App.css";
import ProjectList from "./ProjectList";

function App() {
  return (
    <div className="app">
      <ProjectList />
    </div>
  );
}

export default App;
